import Vue from "vue"
import Vuex from "vuex"
import createPersistedState from "vuex-persistedstate"

Vue.use(Vuex)

const modulesFiles = require.context('./modules', true, /\.js$/)
const modules = modulesFiles.keys().reduce((modules, modulePath) => {
  const moduleName = modulePath.replace(/^\.\/(.*)\.\w+$/, '$1')
  const value = modulesFiles(modulePath)
  modules[moduleName] = value.default
  return modules
}, {})

const state = {
  serverinfo: null,
}

const getters = {
  serverinfo: state => state.serverinfo
}

const mutations = {
  setServerinfo: (state, serverinfo) => {
    state.serverinfo = serverinfo
  },
  clearServerinfo: (state) => {
    state.serverinfo = null
  }
}

const actions = {}

export default new Vuex.Store({
  state,
  getters,
  mutations,
  actions,
  modules,
  plugins: [createPersistedState(
    {
      reducer(state) {
        return {
          serverinfo: state.serverinfo
        }
      }
    }
  )]
})
